import React, { useState } from "react";
import BaseCard from "../../../components/ui/BaseCard";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { fetchUserEducationList } from "../../../services/api/education";
import dayjs from "dayjs";
import { EducationType, UserType } from "../../../utils/enum";
import useAuth from "../../../hooks/useAuth";
import AddEducationModal from "../../CompleteYourProfile/components/AddEducationModal";

const Education = () => {
  const { id: userId } = useParams();
  const { authRole } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEducation, setSelectedEducation] = useState(null);

  const {
    data: userEducationListData,
    isPending: isFetchEducationListLoading,
    error: isFetchEducationListError,
    refetch: refetchUserEducationList,
  } = useQuery({
    queryKey: ["userEducationList"],
    queryFn: () => fetchUserEducationList(userId),
    enabled: !!userId,
  });

  const handleEditClick = (education) => {
    setSelectedEducation(education);
    setIsModalOpen(true);
  };

  const handleAddClick = () => {
    setSelectedEducation(null);
    setIsModalOpen(true);
  };

  return (
    <BaseCard className="py-2 px-8 sm:px-10 rounded-lg" elevation={1}>
      <div className="bg-light -mx-4 px-4 py-2 mt-2 mb-4 rounded-md flex justify-between items-center">
        <h6 className="text-dark font-normal">Education</h6>
        {authRole === UserType.ADMIN && (
          <i
            className="fa-solid fa-circle-plus cursor-pointer text-lg text-secondary"
            style={{ cursor: "pointer" }}
            onClick={handleAddClick}
          ></i>
        )}
      </div>

      {userEducationListData?.data?.map((education) => (
        <div key={education.id}>
          <div className="flex justify-between items-center">
            <div>
              <h6 className="font-normal mb-1">
                Institution Name: <span className="font-300">{education?.institutionName}</span>
              </h6>
              <p className="font-normal text-sm capitalize mb-1">
                Degree:{" "}
                <span className="text-sm font-300">{EducationType[education?.educationType]}</span>
              </p>
              <div className="flex">
                <p className="font-normal text-sm">
                  Start Date:{" "}
                  <span className="font-300">
                    {dayjs(education?.startDate).format("DD/MM/YYYY")}
                  </span>
                </p>
                <p className="font-normal ml-8 text-sm">
                  End Date:{" "}
                  <span className="font-300">{dayjs(education?.endDate).format("DD/MM/YYYY")}</span>
                </p>
              </div>
            </div>
            {authRole === UserType.ADMIN && (
              <i
                className="fa-light fa-pencil text-gray-900 cursor-pointer"
                style={{ cursor: "pointer" }}
                onClick={() => handleEditClick(education)}
              ></i>
            )}
          </div>
          <div className="border-b my-4"></div>
        </div>
      ))}

      {isModalOpen && (
        <AddEducationModal
          open={isModalOpen}
          close={setIsModalOpen}
          refetchUserEducationList={refetchUserEducationList}
          isEdit={!!selectedEducation}
          selectedUserEducation={selectedEducation}
          setSelectedUserEducation={setSelectedEducation}
          targetUserId={userId}
        />
      )}
    </BaseCard>
  );
};

export default Education;
